<template>
<div>
  <div class="form-group">
    <h3 for="finess" class="control-label">
      Taper le Numéro FINESS de l'établissement
    </h3>
    <cleave v-model="finess"
            id="finess"
            :disabled="disabled"
            :options="options"
            class="form-control finess-input"
            placeholder="xxxxxxxxx"
            autocomplete="off">
    </cleave>
    <alert type="info" v-if="showProgress">
      <progress-bar
        v-model="progress"
        striped
        label
        label-text="Récupération des informations auprès du FINESS"
        active />
    </alert>

  </div>
</div>
</template>

<script>
import go from '@/gojs/go'
import finess from '@/sui/api/finess'
import Error from '@/sui/tools/error'

import cleave from 'vue-cleave-component'
import debounce from 'debounce'

export default {
  name: 'get-establishment-from-finess',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    initialFiness: {
      type: String,
      default: ''
    }
  },

  data: function () {
    return {
      finess: this.initialFiness,
      progress: 100,
      target: '',
      finessError: new Error(),
      showProgress: false,
      options: {
        blocks: [9],
        uppercase: true
      },
      establishment: {
        name: {
          field: 'Raison Sociale',
          value: ''
        },
        address: {
          field: 'Adresse',
          value: ''
        }
      }
    }
  },

  methods: {

    debounceFinessRequest: debounce(function (val) {
      this.target = ''
      if (val.length === 9) {
        if (go.etb.isValidFiness(val)) {
          this.collectFinessData(val)
        } else {
          this.finessError.set(
            'Erreur de saisie !',
            `Le numéro FINESS ne contient que des chiffres ou les lettres
A ou B (uniquement pour les établissements corses).`
          )
        }
      } else if (val.length > 0) {
        this.finessError.set(
          'Erreur de saisie !',
          'Le numéro FINESS doit contenir 9 caractères.'
        )
      } else {
        this.finessError.reset()
      }
    }, 500),

    collectFinessData (val) {
      if (this.source !== undefined) {
        this.source.cancel('Operation cancelled by a new request')
      } else {
        this.source = finess.getCancelTokenSource()
      }

      this.showProgress = true
      this.finessError.reset()

      const vm = this
      finess.info(val, this.source.token)
        .then(function (response) {
          const { data } = response
          if (data.err == null) {
            vm.$emit(
              'result',
              {
                target: data.id,
                name: data.n,
                finess: vm.finess,
                address: data.a
              }
            )
            vm.endFinessRequest()
          } else {
            vm.finessError.set(
              'Numéro FINESS Inconnu !',
              'Aucun établissement trouvé avec ce numéro FINESS.',
              'Merci de vérifier votre saisie.',
              false
            )
            vm.endFinessRequest()
          }
        }).catch(function (e) {
          vm.finessError.set(
            'Erreur interne !',
            `Une erreur inattendue s'est produite lors de la recherche de
            votre établissement.`,
            `Vérifiez votre connexion internet avant de réessayer.`

          )
          vm.endFinessRequest()
        })
    },

    endFinessRequest () {
      this.showProgress = false
      this.source = undefined
    }
  },

  watch: {
    initialFiness: function (f) {
      this.finess = f
    },

    finessError: {
      handler: function (v) {
        this.$emit('error', v)
      },
      deep: true
    },

    finess: function (v) {
      this.debounceFinessRequest(v)
    }
  },

  components: {
    'cleave': cleave
  }
}
</script>
<style lang="less" scoped>
input[type="number"] {
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
}
.progress {
    margin-bottom: 0px;
}

.finess-input {
  margin-bottom: 1rem;
}
</style>
